<template>
    <div class="table-container">
        <div class="title">
            <span>
                SMS Campaigns
            </span>
            <div>
                <v-btn
                    :disabled="!hasCreatePrivilege"
                    class="edit-btn"
                    @click="goToCreateSMSCampaign()"
                >
                    Create New
                </v-btn>
            </div>
        </div>
        <array-filters :is-search-in-progress="isFetchingCampaigns" />
        <array-view
            :items="smsCampaigns"
            :headers="headers"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :total-items="totalItems"
            :is-edit-disabled="!hasEditPrivilege"
            :is-delete-disabled="!hasDeletePrivilege"
            :is-fetching="isFetchingCampaigns"
            @refresh-data="refreshData"
            @paginationChange="paginationChange"
            @updateCampaign="updateCampaignItem"
            @deleteCampaign="deleteCampaign"
        />
    </div>
</template>

<script>
    import smsCampaignService from '@/services/sms-campaign-service'
    import ArrayFilters from '@/components/ArrayFilters'
    import ArrayView from '@/components/ArrayView'
    import { hasPrivilege } from '@/utils/userUtils'
    import { PRIVILEGES } from '@/utils/consts'
    export default {
        components: { ArrayView, ArrayFilters },
        data() {
            return {
                headers: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'User',
                        value: 'username'
                    },
                    { text: 'Originator', value: 'originator' },
                    { text: 'Status', value: 'status' },
                    { text: 'Delivery Rate', value: 'deliveryRate' },
                    { text: 'Created At', value: 'createdAt' },
                    { text: 'Scheduled At', value: 'scheduledAt' },
                    { text: 'Started At', value: 'startedAt' },
                    { text: 'Completed At', value: 'completedAt' },
                    { text: 'Alias', value: 'alias' },
                    { text: 'Actions', align: 'center', value: 'actions', sortable: false }
                ],
                smsCampaigns: null,
                totalPages: 0,
                size: 5,
                page: 1,
                totalItems: 0,
                isFetchingCampaigns: false
            }
        },
        computed: {
            arrayFilters() {
                return this.$store.getters.getCurrentArrayFilters
            },
            hasDeletePrivilege() {
                return hasPrivilege(
                    PRIVILEGES.SMS_CAMPAIGN_DELETE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasEditPrivilege() {
                return hasPrivilege(
                    PRIVILEGES.SMS_CAMPAIGN_UPDATE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasCreatePrivilege() {
                return hasPrivilege(
                    PRIVILEGES.SMS_CAMPAIGN_CREATE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            }
        },
        watch: {
            arrayFilters() {
                this.page = 1
                this.fetchAllSMSCampaigns()
            }
        },
        created() {
            this.$store.dispatch('clearFiltersOnCreate')
            this.page = this.$route.query.page ? parseInt(this.$route.query.page) : this.page
            this.fetchAllSMSCampaigns()
        },
        methods: {
            refreshData() {
                this.fetchAllSMSCampaigns()
            },
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.fetchAllSMSCampaigns()
            },
            goToCreateSMSCampaign() {
                this.$router.push('/sms/create')
            },
            fetchAllSMSCampaigns() {
                this.isFetchingCampaigns = true
                smsCampaignService.getAllSMSCampaigns({ filter: this.arrayFilters, range: [this.page - 1, this.size] }).then(resp => {
                    this.smsCampaigns = resp.data.content
                    this.totalPages = resp.data.totalPages
                    this.totalItems = resp.data.totalElements
                }).finally(() => {
                    this.isFetchingCampaigns = false
                })
            },
            updateCampaignItem(campaignIndex, property, val) {
                const campaign = this.smsCampaigns.find(c => c.id === campaignIndex)
                campaign[property] = val
            },
            deleteCampaign(id) {
                this.smsCampaigns = this.smsCampaigns.filter(campaign => campaign.id !== id)
            }
        }
    }
</script>

<style scoped>
    .title {
        font-size: 1.5rem !important;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .edit-btn {
        text-transform: none !important;
        background: #00acd6 !important;
        color: white;
        margin: 15px auto;
    }

</style>
